import { logo } from "assets/icons";
import { authImg } from "assets/images";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { userData } from "utils/userData";

export default function AuthLayout({ children, title, submit }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (userData) {
      navigate("/dashboard");
    }
    //eslint-disable-next-line
  }, []);
  return (
    <AuthLayoutStyle>
      <div className="body">
        <div className="layout">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="img">
            <img src={authImg} alt="" />
          </div>
        </div>
        <div className="child">
          <div></div>
          <div className="div">
            <h1>{title}</h1>
            <form onSubmit={submit}>{children}</form>
          </div>
          <div className="footer">
            <span>Unified Payment@2022</span>
            <span>Privacy policy</span>
            <span>Terms & Condition</span>
          </div>
        </div>
      </div>
    </AuthLayoutStyle>
  );
}

const AuthLayoutStyle = styled.div`
  width: 100%;
  height: 100vh;

  .body {
    width: 100%;
    height: 100vh;
    max-width: 1680px;
    margin: 0 auto;
    display: grid;
    background: #f5fcff;
    grid-template-columns: 5fr 4fr;
    grid-gap: 20px;
    .layout {
      width: 100%;

      .logo {
        padding: 20px;
      }

      .img {
        width: 90%;
        max-width: 800px;
        margin: auto;
        height: 80%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .child {
      background: #04a3e5;
      border-radius: 20px 0px 0px 20px;
      width: 100%;
      height: 100vh;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h1 {
        margin-bottom: 40px;
      }
      .div {
        padding: 0 50px;
      }
      .footer {
        display: flex;
        justify-content: space-around;
        align-items: end;
        padding: 50px;

        span {
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width: 930px) {
    .body {
      grid-template-columns: 1fr;
      gap: 0;

      .img {
        display: none;
      }

      .child {
        border-radius: 20px 20px 0px 0px;
        overflow: hidden;

        h1 {
          font-size: 26px;
        }
        .div {
          padding: 0 20px;
        }

        .footer {
          padding: 20px;
        }
      }
    }
  }
`;
